import type { Baseline, Project } from '../models/project.model';
import { getAllBuildingVersions } from './recursive-element.helpers';
import { replaceBuildingVersionInProject } from './project.helpers';

/**
 * True when a baseline still carries the pre-DEV-3491 embedded catalog key.
 */
export const hasEmbeddedRecipesKey = (version: Baseline): boolean =>
  Object.prototype.hasOwnProperty.call(version, 'recipes');

/**
 * Drop the legacy `recipes` catalog key from a baseline.
 * Same reference when the key is already absent.
 */
export const omitEmbeddedRecipesFromVersion = (version: Baseline): Baseline => {
  if (!hasEmbeddedRecipesKey(version)) return version;
  // Copy then drop so the original baseline object stays untouched.
  const next = { ...version };
  Reflect.deleteProperty(next, 'recipes');
  return next;
};

/**
 * Drop embedded `recipes` from every baseline in {@link project}.
 * Same reference when none of the versions still define the key.
 */
export const omitEmbeddedRecipesFromProject = (project: Project): Project => {
  let next = project;
  for (const version of getAllBuildingVersions(project)) {
    const stripped = omitEmbeddedRecipesFromVersion(version);
    if (stripped === version) continue;
    next = replaceBuildingVersionInProject(next, stripped);
  }
  return next;
};
